/** Card s tabulkou bez vlastního <thead> — používá Dashboard a ThisWeek/NextWeek. */

import type { ReactNode } from "react";

export function CardTable({ children }: { children: ReactNode }) {
  return (
    <div className="card" style={{ overflow: "hidden" }}>
      <table className="tbl">
        <tbody>{children}</tbody>
      </table>
    </div>
  );
}
